import { useIntl } from 'react-intl';

const StructureTypeList = () => {
  const intl = useIntl();
  const typeIds = Array.from(
    { length: 12 },
    (_, i) => `structure.types.${i + 1}`,
  );

  return (
    <ul style={{ paddingLeft: 20 }}>
      {typeIds.map((id, idx) => {
        const text = intl.formatMessage({ id });
        const [title, desc] = text.split(':');
        return (
          <li key={idx}>
            <strong>{title.trim()}:</strong> {desc?.trim() ?? ''}
          </li>
        );
      })}
    </ul>
  );
};

export default StructureTypeList;
